<template>
  <!-- 通用流程 -->
  <div class="main-view-container">
    <div v-if="porcessStepCur == 1" class="processS1">
      <div class="view-container">
        <div class="view-left-box">
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            class="demo-ruleForm clearfix"
            label-position="left"
            :rules="rules"
          >
            <el-form-item prop="processName" class="line">
              <div class="title-name">{{ $t('formData.processName') }}</div>
              <el-input
                v-model="ruleForm.processName"
                :placeholder="$t('queryForm.pleaseEnter')"
                :disabled="isView"
              />
            </el-form-item>

            <el-form-item prop="technicalArea" class="line">
              <div class="title-name">{{ $t('formData.technicalArea') }}</div>
              <el-select
                v-model="ruleForm.technicalArea"
                :placeholder="$t('queryForm.pleaseSelect')"
                :disabled="isView"
              >
                <el-option
                  v-for="item in technicalAreaList"
                  :key="item.key"
                  :label="item.text"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>

            <el-form-item prop="status" class="line">
              <div class="title-name">{{ $t('formData.status') }}</div>
              <el-select
                v-model="ruleForm.status"
                :placeholder="$t('queryForm.pleaseSelect')"
                :disabled="isView"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="$t(item.text)"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item prop="remarks" class="line">
              <div class="title-name">{{ $t('formData.remarks') }}</div>
              <el-input
                v-model="ruleForm.remarks"
                type="textarea"
                rows="6"
                :placeholder="$t('queryForm.pleaseEnter')"
                :disabled="isView"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="view-right-box">
          <flow
            ref="flow"
            style="margin-left:auto;margin-right:auto"
            :steps="steps"
            :editable="editableS1"
            :checkable="checkableS1"
            :dragable="dragableS1"
            @selectedStep="selectedStep"
            @stepAdded="stepAdded"
            @stepRemoved="stepRemoved"
          />
        </div>
      </div>
    </div>    
    <div v-if="isView && porcessStepCur == 2" class="view-top-boxS2">
      <div class="flow-base-info">
        <div>
          {{ $t('formData.processName') }}：
          <span class="flow-base-info-itemContent">{{ ruleForm.processName }}</span>
        </div>
        <div>
          {{ $t('formData.technicalArea') }}：
          <template v-for="item in technicalAreaList">
            <span class="flow-base-info-itemContent" :key="item.key" v-if="item.key == ruleForm.technicalArea">
              {{ item.text }}
            </span>
          </template>
        </div>
        <div>
          {{ $t('formData.status') }}：
          <template v-for="item in statusList">
            <span class="flow-base-info-itemContent" :key="item.value" v-if="item.value == ruleForm.status">
              {{ $t(item.text) }}
            </span>
          </template>
        </div>
      </div>
    </div>
    <div v-if="porcessStepCur == 2" class="processS2">
      <div class="view-container">
        <div class="view-left-box view-left-boxS2">
          <flow
            ref="flow"
            style="margin-left:auto;margin-right:auto"
            :steps="steps"
            :editable="editableS2"
            :checkable="checkableS2"
            :dragable="dragableS2"
            @selectedStep="selectedStep"
          />
        </div>
        <div class="view-right-box view-right-boxS2">
          <div class="boxTitle">
            <div>
              {{ stepCur ? stepCur.stepName : '' }}
            </div>
          </div>
          <div class="checkListContainer">
            <div class="checkListTitle">
              {{ $t("formData.action") }}
            </div>
            <checklist
              style="margin-left:auto;margin-right:auto;margin-top:30px;"
              :type="checkListType"
              :data="checkListCur"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="porcessStepCur == 1" class="footer-bar-custom" :key="comKey">
      <cus-btn type="cancel" @click="cancel"></cus-btn>
      <cus-btn v-if="!isView" type="next" style="margin-left:80px;" @click="next"></cus-btn>
    </div>
    <div v-if="porcessStepCur == 2" class="footer-bar-custom" :key="comKey">
      <cus-btn type="cancel" @click="cancel"></cus-btn>
      <cus-btn v-if="!isView" type="save" :loading="saveLoding" style="margin-left:80px;" @click="save(false)"></cus-btn>
      <cus-btn v-if="!isView" type="submit" :loading="submitLoading" style="margin-left:80px;" @click="submit()"></cus-btn>
      <cus-btn v-if="!isView" type="previousStep" style="margin-left:80px;" @click="previous"></cus-btn>
    </div>
  </div>
</template>

<script>
import { baseProcessSelectDetails, baseProcessSave, baseProcessUpdate } from '@/api/generalProcessManagement'

export default {
  name: 'GeneralProcessViewCom',
  components: {},
  props: {
    isEdit: {// 是否编辑
      type: Boolean,
      default: false
    },
    isView: {// 是否查看
      type: Boolean,
      default: false
    },
    isCopy: {// 是否赋值
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      comKey: 1,
      backToPage: 'generalProcessManagement',
      saveLoding: false,
      submitLoading: false,
      ruleForm: {
        processName: '',
        technicalArea: '',
        status: 0,
        remarks: ''
      },
      editableS1: false, // 是否可编辑
      checkableS1: false, // 是否显示选择
      dragableS1: true, //是否可拖拽
      editableS2: false, // 是否可编辑
      checkableS2: false, // 是否显示选择
      dragableS2: false, //是否可拖拽
      steps: [
        { stepName: '', checked: false, selected: false }
        // { stepName: '', checked: true },
        // { stepName: '', checked: true },
        // { checked: false },
        // { stepName: '', checked: true}
      ],
      porcessStepCur: 1, // 当前流程步骤
      checkListType: 'editview', // checkList类型
      stepCur: null, // 当前步骤
      checkListCur: [// 当前checklist
        // {
        //   fileList: [],
        //   index: "1",
        //   content: "",
        //   type: "edit",
        //   isNeedAttachments: false,
        //   status: null,
        //   changeStatus: "new",
        //   answerfileList: []
        // }
      ],
      technicalAreaList: [],
      statusList: [
        {
          value: 0,
          text: 'queryForm.enable'
        },
        {
          value: 1,
          text: 'queryForm.disable'
        }
      ],
      // rules: {
      //   processName: [
      //     { required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' },
      //     { min: 1, max: 30, message: this.$t('messageCommon.lengthSectionFormatter',['1','30']), trigger: 'blur' }
      //   ],
      //   technicalArea: [
      //     { required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }
      //   ],
      //   status: [
      //     { required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }
      //   ],
      //   remarks: [
      //     { min: 1, max: 200, message: this.$t('messageCommon.lengthSectionFormatter',['1','200']), trigger: 'blur' }
      //   ]
      // }
    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    },
    rules() {
      return {
        processName: [
          { required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' },
          { min: 1, max: 30, message: this.$t('messageCommon.lengthSectionFormatter',['1','30']), trigger: 'blur' }
        ],
        technicalArea: [
          { required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }
        ],
        status: [
          { required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }
        ],
        remarks: [
          { min: 1, max: 1000, message: this.$t('messageCommon.lengthSectionFormatter',['1','1000']), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    lang() {
      // this.elMainKey++;
      this.getEnumsDictionariesList(1, this.technicalAreaList)
      // this.setFormRulesMessage()
    }
  },
  mounted() {
    const self = this
    window.genalProcessViewCom = self
    // this.setFormRulesMessage()
    this.getEnumsDictionariesList(1, this.technicalAreaList, this.loadData)
    // this.loadData()
  },
  methods: {
    /**
     * 加载数据
     */
    loadData() {
      if (this.isEdit || this.isView || this.isCopy) {
        // 编辑或查看、复制
        let id = this.$route.query.id
        if(this.isCopy){
          id = this.$route.query.copyId
        }
        baseProcessSelectDetails(id)
          .then(result => {
            if (result.code == 200) {
              const data = result.data
              // Object.assign(this.ruleForm, data)
              // console.log(result.data)
              if(this.isCopy){
                data.id = ''//如果是复制的，则把id清空
              }

              this.setProcessObj(data)

              if(this.isView){
                //如果是查看，就直接到第二页
                // const self = this
                // let timeoutObj= window.setTimeout(function(){
                //   window.clearTimeout(timeoutObj)
                //   self.loadOnlyView()// self.next()
                // },10)    
                this.$nextTick(()=>{
                  this.loadOnlyView()
                })            
              }
            } else {
              // this.$message({
              //   type: 'error',
              //   message: result.message
              // })
            }
          })
          .catch(() => {
            // this.$message({
            //   type: "error",
            //   message: "获取信息失败"
            // });
          })
      } else {
        // 新增
      }

      if (this.isView) {
        // 查看
        this.editableS1 = false
        this.checkListType = 'editview'
        this.porcessStepCur = 2//如果是查看，就直接到第二页
      } else {
        this.editableS1 = true
        this.checkListType = 'edit'
      }
    },

    /**
     * 设置表单验证规则
     */
    setFormRulesMessage() {
     this.rules.processName[0].message = this.$t('queryForm.pleaseEnter')
     this.rules.processName[1].message = this.$t('messageCommon.lengthSectionFormatter',['1','30'])
     this.rules.technicalArea[0].message = this.$t('queryForm.pleaseSelect')
     this.rules.status[0].message = this.$t('queryForm.pleaseSelect')
     this.rules.remarks[0].message = this.$t('messageCommon.lengthSectionFormatter',['1','200'])
     if(this.ruleForm.key){
       this.ruleForm.key++
     }
     else{
       this.ruleForm.key=1
     }
    //this.rules = {
    //     processName: [
    //       { required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' },
    //       { min: 1, max: 30, message: this.$t('messageCommon.lengthSectionFormatter',['1','30']), trigger: 'blur' }
    //     ],
    //     technicalArea: [
    //       { required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }
    //     ],
    //     status: [
    //       { required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }
    //     ],
    //     remarks: [
    //       { min: 1, max: 200, message: this.$t('messageCommon.lengthSectionFormatter',['1','200']), trigger: 'blur' }
    //     ]
    //   }
    },

    /**
     * 检查当前checkList
     */
    checkCheckListCur() {
      const checkListCur = this.checkListCur
      if (this.porcessStepCur == 2 && checkListCur && checkListCur.length > 0) {
        for (let i = 0; i < checkListCur.length; i++) {
          const checkItemCur = checkListCur[i]
          if (!checkItemCur.content) {
            const message = this.$t("messageCommon.articleRecordsErrorFormatter",[(i + 1).toString(),this.$t("formData.introduction"),this.$t("messageCommon.beMandatory")])
            this.$message({
              type: 'warning',
              message: message
            })
            return false
          }
        }
      }

      return true
    },

    /**
     * 检查所有checkList
     */
    checkCheckListAll() {
      const steps = this.steps
      if (!steps) {
        return true
      }
      for (let i = 0; i < steps.length; i++) {
        const step = steps[i]
        const checkList = step.checkList
        if (!checkList) {
          // continue
          //如果checkList不存在，则肯定没有说明
          const message = this.$t("messageCommon.articleStepsRecordsErrorFormatter",[(i + 1).toString(),(1).toString(),this.$t("formData.introductionLower"),this.$t("messageCommon.beMandatory")])
          this.$message({
            type: 'warning',
            message: message
          })
          return false
        }
        for (let m = 0; m < checkList.length; m++) {
          const checkItem = checkList[m]
          if (!checkItem.content) {
            const message = this.$t("messageCommon.articleStepsRecordsErrorFormatter",[(i + 1).toString(),(m + 1).toString(),this.$t("formData.introductionLower"),this.$t("messageCommon.beMandatory")])
            this.$message({
              type: 'warning',
              message: message
            })
            return false
          }
        }
      }

      return true
    },

    /**
     * 当前活动步骤
     */
    selectedStep(step) {
      // console.log(step)
      if(this.stepCur == step){
        return
      }
      const isCheck = true//this.checkCheckListCur()
      if (!isCheck) {
        return
      }
      if (!step.checkList || step.checkList.length == 0) {
        const checkListDefault = [// 默认的checklist
          {
            fileList: [],
            index: '1',
            content: '',
            type: 'edit',
            isNeedAttachments: false,
            status: null,
            changeStatus: 'new',
            answerfileList: [],
            link: '',
            linkList:[],
            isSchedule: false
          }
        ]
        step.checkList = checkListDefault
      }

      this.checkListCur = step.checkList
      this.stepCur = step
    },

    /** 新增步骤 */
    stepAdded(){
      //滚动条自动滚动到下个步骤位置
      let viewRightBoxs = document.getElementsByClassName("view-right-box")
      if(viewRightBoxs && viewRightBoxs.length > 0){
        let viewRightBox = viewRightBoxs[0]
        // console.log(viewRightBox.scrollTop,viewRightBox.offsetHeight)
        viewRightBox.scrollTop = viewRightBox.offsetHeight
      }
    },

    /** 删除步骤 */
    stepRemoved(indexR, stepR){
      //阶段裁剪后，阶段的action item自动合并至上一个阶段 
      let steps = this.steps//流程阶段集合
      if(!steps || steps.length == 0){
        return
      }
      if(steps.length < indexR){
        return
      }
      let checkListR = stepR.checkList//被删除的阶段的checkList
      let checkListNew = []//新checkList
      let checkListMerge = []//被合并到的阶段的checkList
      let indexMerge = 0//被合并到的流程阶段的序号
      if(indexR == 0){
        //被删除的序号为第一个，则checkList合并到下一个流程阶段中
        indexMerge = indexR//由于现在的列表中已经删除了一个，所以序号还是0
        checkListMerge = steps[indexMerge].checkList || []
        checkListNew = checkListR.concat(checkListMerge)
      }
      else {
        //被删除的序号不是第一个，则checkList合并到上一个流程阶段中
        indexMerge = indexR - 1
        if(indexMerge < 0){
          indexMerge = 0
        }
        checkListMerge = steps[indexMerge].checkList || []
        checkListNew = checkListMerge.concat(checkListR)
      }
      steps[indexMerge].checkList = checkListNew
    },

    /** 通过stepid 选中 */
    selectStep(id){
      this.$refs.flow.selectStep(id)
    },
    selectStepIndex(index){
      this.$refs.flow.selectStepIndex(index);
    },

    /**
     * 加载查看页
     */
    loadOnlyView(){
      this.porcessStepCur = 2//this.porcessStepCur++
      this.comKey++
      this.checkListCur = []
      this.stepCur = null
      // this.selectedStep(steps[0])
      this.selectStepIndex(0)
    },

    /**
     * 下一步
     */
    next() {
      // console.log(this.steps)
      this.$refs['ruleForm'].validate(isValid => {
        if (isValid) {
          const steps = this.steps
          for (let i = 0; i < steps.length; i++) {
            const step = steps[i]
            if (!step.stepName) {
              const message = this.$t("messageCommon.articleStepsErrorFormatter",[(i + 1).toString(),this.$t("formData.stepName"),this.$t("messageCommon.beMandatory")])
              this.$message({
                type: 'warning',
                message: message
              })
              return
            }
          }

          this.porcessStepCur++
          this.comKey++
          this.checkListCur = []
          this.stepCur = null
          // this.selectedStep(steps[0])
          this.selectStepIndex(0)
        } else {
          return
        }
      })
    },

    /**
     * 上一步
     */
    previous() {
      // console.log(this.steps)
      if(this.stepCur){
        this.stepCur.selected = false
      }
      this.porcessStepCur--
      this.comKey++
    },

    /**
     * 返回上一页
     */
    cancel() {
      let backToPage = this.backToPage
      if (this.$route.query.backToPage) {
        backToPage = this.$route.query.backToPage
      }
      this.$router.push({
        name: backToPage
      })
    },

    /**
     * 保存
     */
    save(isSubmit) {
      // console.log(this.steps)
      let isValid = true
      if (isSubmit) {
        this.submitLoading = true
        isValid = this.checkCheckListAll()
      } else {
        this.saveLoding = true
      }
      
      // this.$refs['ruleForm'].validate(isValid => {
      //, errorFielsObj
      if (isValid) {
        const id = this.$route.query.id
        const formData = this.getProcessObj()
        if (isSubmit) {
          formData.status = 0  
          this.ruleForm.status = 0
        } else {
          formData.status = 1  
          this.ruleForm.status = 1
        }
        if (!id) {
          // 新增
          baseProcessSave(formData)
            .then(result => {
              if (result.code == 200) {
                this.$message({
                  type: 'success',
                  message: result.message
                })

                // if (isSubmit) {
                  this.cancel()
                // }
              } else {
                // this.$message({
                //   type: 'error',
                //   message: result.message
                // })
              }

              if (isSubmit) {
                this.submitLoading = false
              } else {
                this.saveLoding = false
              }
            })
            .catch(() => {
              // this.$message({
              //   type: "error",
              //   message: "保存失败"
              // });

              if (isSubmit) {
                this.submitLoading = false
              } else {
                this.saveLoding = false
              }
            })
        } else {
          // console.log(this.formData)
          // 修改          
          baseProcessUpdate(formData)
            .then(result => {
              if (result.code == 200) {
                this.$message({
                  type: 'success',
                  message: result.message
                })
                baseProcessSelectDetails(id)
                .then(res => {
                  if (res.code == 200) {
                    var selectStepIndex=this.steps.indexOf(this.stepCur);
                    this.setProcessObj(res.data)
                    this.steps[selectStepIndex].selected=true;
                    this.stepCur= this.steps[selectStepIndex];
                    this.checkListCur=this.steps[selectStepIndex].checkList;
                  } 
                })
                if (isSubmit) {
                  this.cancel()
                }
              } else {
                // this.$message({
                //   type: 'error',
                //   message: result.message
                // })
              }

              if (isSubmit) {
                this.submitLoading = false
              } else {
                this.saveLoding = false
              }
            })
            .catch(() => {
              // this.$message({
              //   type: "error",
              //   message: "保存失败"
              // });

              if (isSubmit) {
                this.submitLoading = false
              } else {
                this.saveLoding = false
              }
            })
        }
      } else {
        if (isSubmit) {
          this.submitLoading = false
        } else {
          this.saveLoding = false
        }
        return
      }
      // })
    },

    /**
     * 提交
     */
    submit() {
      // console.log(this.steps)
      this.save(true)
    },

    /**
     * 设置流程对象
     */
    setProcessObj(data) {
      if (!data) {
        return
      }
      this.ruleForm.id = data.id
      this.ruleForm.processName = data.processName
      this.ruleForm.technicalArea = data.technicalArea
      this.ruleForm.status = data.status
      this.ruleForm.remarks = data.remarks
      this.ruleForm.createName = data.createName
      this.ruleForm.updateName = data.updateName

      const basePhases = data.basePhases// 流程步骤列表
      const stepArray = []
      if (basePhases) {
        for (let i = 0; i < basePhases.length; i++) {
          const basePhase = basePhases[i]// 流程步骤
          const step = {
            id: basePhase.id,
            sort: basePhase.sort,
            code: basePhase.code,
            stepName: basePhase.stageName,
            checked:false,  // 勾选状态，当 checkable 为true时有效
            selected:false,  // 当前选中的步骤，选中时 显示橙色且有阴影    整个flow最多出现1个 selected
            isCurrent: false,  // 是否为当前步骤，显示为当前的icon       整个flow最多出现1个 isCurrent
            // unexecuted: false,  // 未执行状态，当为true时，显示为灰色
            // processId: basePhase.processId
          }

          const baseChecks = basePhase.baseChecks// 流程步骤checkList
          const checkList = []
          if (baseChecks) {
            for (let m = 0; m < baseChecks.length; m++) {
              const baseCheck = baseChecks[m]
              const checkItem = {
                index: baseCheck.sort,
                content: baseCheck.introduction,
                type: 'edit',
                isNeedAttachments: (baseCheck.isAttachments == 1),
                changeStatus: 'new',
                answerfileList: [],
                isSchedule: baseCheck.isSchedule == 1,//是否需要填写日程(0-不需要 1-需要)
                link: baseCheck.link,//链接
                linkList: baseCheck.checkLinks
                    ? baseCheck.checkLinks.map(link => {
                        return {
                          linkName: link.linkName,
                          hyperlink: link.link
                        };
                      })
                    : [],
                isPush:baseCheck.isPush
                // phaseId: baseCheck.phaseId,
                // processId: baseCheck.processId
              }

              const baseFile = baseCheck.baseFile// 附件列表
              const fileList = []
              if (baseFile) {
                baseFile.forEach(fileItem => {
                  const file = {
                    filename: fileItem.fileName,
                    filepath: fileItem.fileUrl,
                    filesize: fileItem.fileSize
                  }
                  fileList.push(file)
                })
              }
              checkItem.fileList = fileList

              checkList.push(checkItem)
            }
          }
          step.checkList = checkList

          stepArray.push(step)
        }
      }

      this.steps = stepArray
    },

    /**
     * 获取流程对象
     */
    getProcessObj() {
      const processObj = {}
      const ruleForm = this.ruleForm
      processObj.id = ruleForm.id
      processObj.processName = ruleForm.processName
      processObj.technicalArea = ruleForm.technicalArea
      processObj.status = ruleForm.status
      processObj.remarks = ruleForm.remarks

      const basePhases = []// 流程步骤列表
      const stepArray = this.steps// 当前流程步骤列表
      if (stepArray) {
        for (let i = 0; i < stepArray.length; i++) {
          const step = stepArray[i]// 流程步骤
          const basePhase = {
            id: step.id ? step.id : null,
            sort: i + 1,
            code: step.code,
            stageName: step.stepName,
            checked: false
          }

          const baseChecks = []// 流程步骤checkList
          const checkList = step.checkList
          if (checkList) {
            for (let m = 0; m < checkList.length; m++) {
              const checkItem = checkList[m]
              const baseCheck = {
                sort: m + 1,
                introduction: checkItem.content,
                isAttachments: (checkItem.isNeedAttachments ? 1 : 0),
                isSchedule: checkItem.isSchedule ? 1 : 0,//是否需要填写日程(0-不需要 1-需要)
                link: checkItem.link,//链接
                checkLinks: checkItem.linkList
                    ? checkItem.linkList.map((link,linkIndex) => {
                        return {
                          sort: linkIndex + 1,
                          linkName: link.linkName,
                          link: link.hyperlink
                        };
                      })
                : [],
                isPush: checkItem.isPush
              }

              const baseFile = []// 附件列表
              const fileList = checkItem.fileList
              if (fileList) {
                fileList.forEach(fileItem => {
                  const file = {
                    fileName: fileItem.filename,
                    fileUrl: fileItem.filepath,
                    fileSize: fileItem.filesize
                  }
                  baseFile.push(file)
                })
              }
              baseCheck.baseFile = baseFile

              baseChecks.push(baseCheck)
            }
          }
          basePhase.baseChecks = baseChecks

          basePhases.push(basePhase)
        }
      }

      processObj.basePhases = basePhases

      return processObj
    }
  }
}
</script>

<style scoped lang="scss">
.main-view-container{
  // width: 100%;
  min-width:1080px;
  height: 100%;
  min-height: 460px;
  // display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
  // display: -moz-box; /* Firefox 17- */  
  // display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
  // display: -moz-flex; /* Firefox 18+ */  
  // display: -ms-flexbox; /* IE 10 */  
  display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */  
  flex-direction: column;
  // overflow: auto;
}

.processS1{
  height: 50%;
  // display: flex;
  // flex-direction: column;
  flex-grow:1;
}

.processS2{
  height: 50%;
  // display: flex;
  // flex-direction: column;
  flex-grow:1;
}

.view-container{
  height: 100%;//570px;//calc(100% - 90px);
  min-height: 200px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  // flex-wrap: wrap;
}

.view-left-box {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  // padding-top: 30px;
  // margin-bottom: 90px;
  height: 100%;//calc(100% - 30px);
  overflow: auto;
  width:36%;//380px;
  min-width:380px;
  margin-right:10px;
  flex-grow: 1;

  .demo-ruleForm {
    width: 350px;
    padding-top: 30px;
    padding-bottom: 20px;

    .el-form-item {
      .content {
        color: rgba(102, 102, 102, 1);
      }
    }

    .line {
      width: 100%;
    }

    // .line .el-input {
    //     width: 350px;
    // }

    // .line .el-textarea {
    //     width: 350px;
    // }
  }
}

.view-right-box {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  // padding-top: 30px;
  // margin-bottom: 90px;
  height: 100%;
  // min-height: 100%;
  overflow: auto;
  width: 63%;//380px;
  min-width: 430px;
  flex-grow: 2;
}

.view-top-boxS2{
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  // height: 80px;
  min-width: 888px;
  // overflow: auto;
  margin-bottom: 10px;
  padding: 15px 20px;

  .flow-base-info{
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    justify-content: space-between;
    height: 60px;//100%;
  }

  .flow-base-info > div{
    width: 49%;
    font-size: 18px;
    // margin-bottom: 15px;
    word-break: keep-all;
    word-wrap: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .flow-base-info-itemTitle{
      color: black;
    }

    .flow-base-info-itemContent{
      color: rgb(96, 98, 102);//rgb(0, 0, 0);//rgb(110, 110, 110);//rgb(51, 51, 51);
    }
  }
}

.view-left-boxS2 {
  width: 40%;//380px;
  min-width: 430px;
  // padding-top: 0;
  flex-grow: 1;
}

.view-right-boxS2 {
  width: 59%;//380px;
  height: 100%;
  overflow: auto;
  min-width: 380px;
  // padding: 20px 0 0 0;
  flex-grow: 1;

  .boxTitle{
    font-size: 22px;
    font-weight: 500;
    color: rgba(2,159,231,1);
    line-height: 30px;
    height: 30px;
    padding: 0 10px;
    margin-top: 15px;
  }

  .checkListContainer{
    padding: 20px 20px;

    .checkListTitle{
      text-align: center;
      font-size: 16px;
      color: rgba(51,51,51,1);
      border-bottom: #C4C4C4 solid 1px;
      padding-bottom: 5px;
    }
  }
}
</style>
